/* tslint:disable:max-line-length */
import formatCurrency from '../utilities/formatCurrency'
import i18n from '../i18n'
import { i18nKeys } from 'translationTypes'

export type GECampaign = {
  currency: 'USD' | 'CAD'
  guaranteed_earnings: number
  id: number
  is_expired: boolean
  num_days_to_complete: number
  num_deliveries_required: number
  submarket_name: string
}

export const generateTestStub = (options = {}) => ({
  currency: null,
  guaranteed_earnings: 100000,
  id: 1,
  is_expired: false,
  num_days_to_complete: 10,
  num_deliveries_required: 100,
  submarket_name: 'Silicon Valley',
  ...options,
})

const currencySymbols = {
  USD: '$',
  CAD: 'CA$',
}

const getEarningsString = (guaranteedEarningsCampaign: GECampaign) =>
  `${currencySymbols[guaranteedEarningsCampaign.currency] ||
    '$'}${formatCurrency(guaranteedEarningsCampaign.guaranteed_earnings, {
    showCents: false,
  })}`

export const getTitleCopy = guaranteedEarningsCampaign =>
  i18n.t(i18nKeys.earningsCampaign__title_copy, { earnings: getEarningsString(guaranteedEarningsCampaign), numDeliveries: guaranteedEarningsCampaign.num_deliveries_required, submarket: guaranteedEarningsCampaign.submarket_name })

export const getTermsCopy = guaranteedEarningsCampaign =>
  i18n.t(i18nKeys.earningsCampaign__terms, {
    earnings: getEarningsString(guaranteedEarningsCampaign),
    numDeliveries: guaranteedEarningsCampaign.num_deliveries_required,
    submarket: guaranteedEarningsCampaign.submarket_name,
    numDays: guaranteedEarningsCampaign.num_days_to_complete
  })
export const getModalTitle = guaranteedEarningsCampaign =>
  i18n.t(i18nKeys.earningsCampaign__modal_title, {
    earnings: getEarningsString(guaranteedEarningsCampaign),
    numDeliveries: guaranteedEarningsCampaign.num_deliveries_required,
    submarket: guaranteedEarningsCampaign.submarket_name,
    numDays: guaranteedEarningsCampaign.num_days_to_complete
  })

export const getSignupTitle = guaranteedEarningsCampaign =>
  i18n.t(
    i18nKeys.earningsCampaign__signup,
    { earnings: getEarningsString(guaranteedEarningsCampaign), }
  )
